import { DefaultValue } from "recoil";

const tabSyncEffect = (key) => ({setSelf, onSet}) => {
  setSelf(new DefaultValue());

  onSet(newValue => {
    localStorage.setItem(key, JSON.stringify(newValue));
  });

  window.addEventListener('storage', (e) => {
    if (key === e.key) {
      setSelf(JSON.parse(e.newValue));
    }
  });
};

export default tabSyncEffect;